<div class="my-security form-dialog">
  <mat-dialog-content>
    <mat-tab-group #tab_group [disableRipple]="true">
      @if (appScope.current_user) {
        <mat-tab label="Auth Token Setup">
          <form class="form-section column space-between">
            <div class="row">
              <mat-form-field>
                <mat-label>Days before expiring</mat-label>
                <input matInput type="number" step="any" id="days_before_expiry" [(ngModel)]="days" name="days"/>
              </mat-form-field>
              @if (appScope.current_user) {
                <mat-checkbox type="checkbox" id="auth_token" class="self-center"
                  [checked]="appScope.current_user.auth_token_active"
                  [disabled]="false">Auth Token active
                </mat-checkbox>
              }
            </div>
            <div class="row">
              <button mat-button (click)="generateToken()" class="bordered-button">Create</button>
              <button mat-button (click)="deactivateToken()" class="bordered-button">Remove</button>
            </div>
            <div class="row">
              <label>Auth Token: Please copy this, Wire does not store a copy of this token</label>
            </div>
            <div class="row">
              <div style="word-break: break-all;" >{{auth_token}}  </div>
            </div>
          </form>
        </mat-tab>
      }
    </mat-tab-group>
  </mat-dialog-content>
</div>
